export default __webpack_public_path__ + "7831194f3c6801ba39fa9773bb4cf54e.jpg";